"use client";
import {
  __async
} from "../../../chunk-MMUBH76A.js";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { CpslButton, CpslText } from "@getpara/react-components";
import { StepContainer, InnerStepContainer, HeroIcon } from "../common.js";
import { useModalStore, useThemeStore } from "../../stores/index.js";
import { ModalStep } from "../../utils/steps.js";
import { WalletCard, WalletCards } from "../WalletCard/WalletCard.js";
import styled from "styled-components";
import { useInternalClient } from "../../../provider/hooks/utils/useInternalClient.js";
const WalletCreationDoneStep = ({ twoFactorAuthEnabled, onClose }) => {
  const hideWallets = useThemeStore((state) => state.hideWallets);
  const setStep = useModalStore((state) => state.setStep);
  const isLogin = useModalStore((state) => state.isLogin());
  const onRampConfig = useModalStore((state) => state.onRampConfig);
  const para = useInternalClient();
  const isOnRampConfigured = (onRampConfig == null ? void 0 : onRampConfig.isBuyEnabled) || (onRampConfig == null ? void 0 : onRampConfig.isReceiveEnabled) || (onRampConfig == null ? void 0 : onRampConfig.isWithdrawEnabled);
  const handleNext = () => __async(void 0, null, function* () {
    if (isLogin) {
      if (!twoFactorAuthEnabled) {
        setStep(ModalStep.LOGIN_DONE);
        return;
      }
      const { isSetup: is2faComplete } = yield para.check2FAStatus();
      setStep(is2faComplete ? ModalStep.LOGIN_DONE : ModalStep.SETUP_2FA);
    } else {
      if (twoFactorAuthEnabled) {
        setStep(ModalStep.SETUP_2FA);
      } else {
        onClose();
      }
    }
  });
  return /* @__PURE__ */ jsxs(StepContainer, { $wide: true, children: [
    /* @__PURE__ */ jsx(CardContainer, { children: hideWallets ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(HeroIcon, { icon: "checkCircleFilled" }),
      /* @__PURE__ */ jsx(CpslText, { variant: "bodyM", color: "secondary", weight: "medium", style: { marginTop: "16px" }, children: "Your account has been created." })
    ] }) : /* @__PURE__ */ jsx(WalletCards, { children: para.currentWalletIdsArray.map(([id, type]) => {
      return /* @__PURE__ */ jsx(WalletCard, { id, type, showAddFunds: isOnRampConfigured }, id);
    }) }) }),
    /* @__PURE__ */ jsx(InnerStepContainer, { children: /* @__PURE__ */ jsx(CpslButton, { fullWidth: true, onClick: handleNext, children: twoFactorAuthEnabled ? "Continue" : "Done" }) })
  ] });
};
const CardContainer = styled(InnerStepContainer)`
  min-height: 196px;
  justify-content: center;
`;
export {
  WalletCreationDoneStep
};
